import React from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import copy from 'copy-to-clipboard';

const CopyURLIcon = ({ shared, shareUrl }) => {
  if (shared && !isEmpty(shareUrl)) {
    return (
      <div>
        <FontAwesomeIcon
          icon="copy"
          size="lg"
          className="text-primary pr-1 align-center"
          onClick={() => {
            copy(Meteor.absoluteUrl(`${shareUrl}`));
            Bert.alert('Url copied to clipboard', 'info');
          }}
        />
      </div>
    );
  }
  return '';
};

CopyURLIcon.defaultProps = {
  shareUrl: ''
};

CopyURLIcon.propTypes = {
  shared: PropTypes.bool.isRequired,
  shareUrl: PropTypes.string
};

export default CopyURLIcon;
